import React from "react";
import { useRouter } from "next/router";

const TalentIncludedCheckbox = () => {
  const router = useRouter();
  // Default to checked (true) if not specified
  const isChecked = router.query.talent_included !== "false";

  const handleChange = () => {
    const { pathname, query } = router;
    const newQuery = { ...query };

    // Always set the talent_included parameter to maintain state when switching tags
    // This way, when the user switches back to "All" or "Full-time Remote",
    // the checkbox will remember its previous state
    newQuery.talent_included = isChecked ? "false" : "true";

    router.push({
      pathname,
      query: newQuery,
    });
  };

  // The visibility is controlled by the parent component

  return (
    <div className="talent-only-checkbox">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
          className="checkbox-input"
        />
        <div className="checkbox-box">
          {isChecked && (
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.165 9.8791C3.994 9.8791 3.823 9.8135 3.693 9.6836L0.045 6.036C-0.216 5.7748 -0.216 5.3524 0.045 5.0912C0.307 4.8301 0.729 4.8301 0.99 5.0912L4.638 8.7403C4.899 9.0014 4.899 9.4239 4.638 9.685C4.507 9.8149 4.336 9.8791 4.165 9.8791Z"
                fill="white"
              />
              <path
                d="M4.166 9.8794C3.995 9.8794 3.824 9.8138 3.694 9.6839C3.433 9.4228 3.433 9.0003 3.694 8.7392L10.991 1.4439C11.252 1.18276 11.674 1.18276 11.935 1.4439C12.196 1.70503 12.196 2.12749 11.935 2.38862L4.639 9.6839C4.507 9.8152 4.336 9.8794 4.166 9.8794Z"
                fill="white"
              />
            </svg>
          )}
        </div>
        <span className="checkbox-text">人才库岗位</span>
      </label>

      <style jsx>{`
        .talent-only-checkbox {
          display: inline-flex;
          align-items: center;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
          gap: 8px;
        }

        .checkbox-input {
          display: none;
        }

        .checkbox-box {
          width: 17px;
          height: 17px;
          border: 1.5px solid #f9ba48;
          border-radius: 1.5px;
          background-color: ${isChecked ? "#F9BA48" : "transparent"};
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .checkbox-text {
          font-size: 14px;
          color: #1b1b1b;
          font-weight: 400;
        }

        .checkbox-label:hover .checkbox-box {
          border-color: ${isChecked ? "#F9BA48" : "#E0A040"};
          background-color: ${isChecked
            ? "#F9BA48"
            : "rgba(249, 186, 72, 0.1)"};
        }
      `}</style>
    </div>
  );
};

export default TalentIncludedCheckbox;
